import { isSafeUrl } from '../url-safety';

export interface LinkCardData {
  title?: string;
  description?: string;
  url?: string;
  cta_label?: string;
}

interface LinkCardProps {
  data: LinkCardData;
}

const ExternalLinkIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

export function LinkCard({ data }: LinkCardProps): React.JSX.Element | null {
  const { title, description, url, cta_label } = data;

  if (!isSafeUrl(url)) return null;

  const ctaLabel = cta_label ?? 'Learn More';

  return (
    <div className="link-card">
      <div className="link-card-body">
        {title && <div className="link-card-title">{title}</div>}
        {description && <div className="link-card-description">{description}</div>}
        <a
          className="link-card-cta"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="link-card-cta-icon" aria-hidden="true">{ExternalLinkIcon}</span>
          {ctaLabel}
        </a>
      </div>
    </div>
  );
}
